import styled from 'styled-components';

export const PageBody = styled.div`
  min-height: calc(100vh - 68px);
  background: #fff;
  display: flex;
  justify-content: center;
`;

export const MainColumn = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const CardSection = styled.div`
  margin-top: 15px;
  width: 100%;
  max-width: 900px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 14px rgba(35,62,88,0.07);
  border: 1px solid #e9eaf3;
  padding: 1.8rem 2rem 2rem 2rem;
`;

export const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 550;
  color: #233E58;
  margin-bottom: 1.8rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 22px;
  margin-bottom: 0.3rem;
`;

export const Label = styled.label`
  color: #263250;
  font-weight: 600;
  margin: 1.5rem 0;
  font-size: 0.96rem;
  display: block;
`;

export const Input = styled.input`
  flex: 1;
  width: 90%;
  border: 1px solid #D9D9D9;
  border-radius: 9px;
  height: 40px;
  font-size: 1rem;
  padding: 0 12px;
  margin-bottom: 1.04rem;
  background: #fff;
  font-family: 'Inter', Arial, sans-serif;
  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;

export const Select = styled.select`
  flex: 1;
  width: 100%;
  border: 1px solid #D9D9D9;
  border-radius: 9px;
  height: 40px;
  font-size: 1rem;
  padding: 0 12px;
  margin-bottom: 1.04rem;
  background: #fff;
  font-family: 'Inter', Arial, sans-serif;
  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 0.95rem;
  padding: 0.9rem;
  width: 100%;
`;

export const TabButton = styled.button`
  flex: 1;
  padding: 0.9rem 0;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.05rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  border: none;
  color: ${(props) => (props.active ? '#132b65ff' : '#8a8a8a')};
`;

export const Button = styled.button`
  background: #3772FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.9rem 0;
  flex: 1;
  font-weight: 600;
  font-size: 1.05rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  &:hover {
    background: #245bb9;
  }
`;

export const ButtonSecondary = styled.button`
  background: #fff;
  color: #3772FF;
  border-radius: 8px;
  border: 1.7px solid #3772FF;
  padding: 0.9rem 0;
  flex: 1;
  font-weight: 500;
  font-size: 1.05rem;
  cursor: pointer;
  &:hover {
    background: #eef6ff;
  }
`;

export const DenominationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  padding: 10px 15px;
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const DenominationAmount = styled.span`
  min-width: 60px;
  color: #233E58;
  font-weight: 700;
  font-size: 1.01rem;
`;

export const DenominationInput = styled(Input)`
  max-width: 60px;
  text-align: right;
  margin-bottom: 0;
`;

export const DenominationTotal = styled.span`
  min-width: 52px;
  text-align: right;
  color: #000000;
  font-weight: 700;
  font-size: 1.01rem;
`;

export const TotalsBox = styled.div`
  background: #f4f6fb;
  color: #233E58;
  border-radius: 7px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 0.74rem 1rem;
  font-size: 0.99rem;
  font-weight: 700;
`;

export const MilkRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
`;

export const MilkInput = styled(Input)`
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
`;

export const MilkLabel = styled(Label)`
  margin-bottom: 4px;
`;

export const InfoCard = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #e9eaf3;
  box-shadow: 0 2px 12px rgba(35,62,88,0.05);
  margin-bottom: 16px;
  margin-top: 16px;
  padding: 1.5rem 2rem 2rem 2rem;
`;

export const ReportHeaderRow = styled.div`
  display: flex;
  gap: 16px;
  font-size: 1.07rem;
  font-weight: 600;
  margin-bottom: 6px;
  justify-content: space-between;
`;

export const ReportGrid = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
`;

export const ItemInput = styled.input`
  flex: 1;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  height: 38px;
  font-size: 1rem;
  padding: 0 12px;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
  background: #fff;
  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;

export const AddBtn = styled.button`
  padding: 0 14px;
  height: 38px;
  border-radius: 8px;
  border: 1.5px solid #cfd8ea;
  background: #f5f7fe;
  color: #3052cc;
  font-size: 1.2rem;
  font-weight: 500;
  margin-left: 6px;
  cursor: pointer;
`;

export const SummaryValue = styled.span`
  float: right;
  font-size: 1.12rem;
  font-weight: 600;
color: ${({ positive, negative }) =>
    positive ? "#18b460" :
    negative ? "#da1111ff" :
    "inherit"};`;

export const summaryLine = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: '1.08rem',
  margin: '0 0 6px 0',
  fontWeight: 400,
  fontFamily: "'Segoe UI', 'Inter', Arial, sans-serif",
};

export const DiscrepancyButton = styled(ButtonSecondary)`
  background-color: #da1111ff;
  color: white;
  border-color: #b00f0f;
  box-shadow: 0 0 6px rgba(218, 17, 17, 0.5);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background-color: #b00f0f;
    box-shadow: 0 0 10px rgba(176, 15, 15, 0.75);
  }
`;
export const InputDigitalSettlement = styled.input.attrs(props => ({
  type: 'text',
  inputMode: 'numeric',
  pattern: '[0-9]*',
}))`
  flex: 1;
  width: 90%;
  border: 1px solid #D9D9D9;
  border-radius: 9px;
  height: 70px;
  font-size: 1rem;
  padding: 10px 12px;
  margin-bottom: 1.04rem;
  background: #fff;
  font-family: 'Inter', Arial, sans-serif;
   /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;
